import { render } from "./TacticalBoardPicker.vue?vue&type=template&id=e863f2be&scoped=true"
import script from "./TacticalBoardPicker.vue?vue&type=script&lang=js"
export * from "./TacticalBoardPicker.vue?vue&type=script&lang=js"

import "./TacticalBoardPicker.vue?vue&type=style&index=0&id=e863f2be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e863f2be"]])

export default __exports__